export default function AboutThree() {
  return (
    <article className="relative bg-gray-900">
      <section className="lg:absolute lg:inset-0 max-w-7xl mx-auto">
        <section className="lg:absolute lg:inset-y-0 lg:left-0 lg:w-1/2">
          <img
            className="h-56 w-full object-cover lg:absolute lg:h-full object-center"
            src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
            alt=""
            aria-hidden="true"
          />
        </section>
      </section>

      <section className="relative pt-12 pb-16 px-4 sm:pt-16 sm:px-6 lg:px-8 lg:max-w-7xl lg:mx-auto lg:grid lg:grid-cols-2 ">
        <section className="lg:col-start-2 lg:pl-8 ">
          <section className="text-base max-w-prose mx-auto lg:max-w-lg lg:ml-auto lg:mr-0 ">
            <h2 className="leading-6 text-[color:var(--primary-font-color)] font-semibold tracking-wide uppercase">
              Collaborate
            </h2>
            <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
              Let's work together
            </h3>
            <p className="mt-8 text-lg text-gray-500">
              In the fast-paced world of social media, collaboration is the catalyst that ignites exponential growth and propels businesses to new heights. At Edgy, we firmly believe that forging meaningful partnerships can unlock unexplored opportunities and expand your reach like never before. In this article, we invite you to embrace the power of collaboration as we work together with other businesses to elevate your Instagram growth and unleash the full potential of your brand.
            </p>
            <section className="mt-5 prose prose-indigo text-gray-500">
              <p className="mt-8 text-lg text-gray-500">
                Collaborating with like-minded businesses amplifies your message and extends your reach beyond your current audience. Our team specializes in identifying strategic partners whose values align with yours, creating a powerful alliance that benefits all parties involved.
              </p>
              <p className="mt-8 text-lg text-gray-500">
                Through cross-promotional efforts, you gain access to untapped audiences who might have otherwise remained undiscovered. By leveraging each other's strengths and followers, you create a win-win situation that drives mutual growth and exposure.
              </p>
              <p className="mt-8 text-lg text-gray-500">
                Working with other businesses injects fresh perspectives and diverse content into your Instagram strategy. This collaboration injects creativity and excitement into your feed, engaging your audience in new and captivating ways.
              </p>
              <p className="mt-8 text-lg text-gray-500">
                Collaborative campaigns and contests are an excellent way to foster engagement and excitement among your followers. By pooling resources and ideas, we craft memorable campaigns that leave a lasting impression on your audience and drive follower acquisition.
              </p>
              <p className="mt-8 text-lg text-gray-500">
                Beyond growing your follower count, collaboration allows you to amplify your social impact. Together, we can support charitable causes, raise awareness for important issues, and foster a sense of community among your followers.
              </p>
              <p className="mt-8 text-lg text-gray-500">
                Influencers have an influential role in modern marketing. We tap into our extensive network of influencers to identify the best-suited partners for your collaborative efforts. These partnerships have the potential to drive immense growth and bring your brand to the forefront of your industry.
              </p>
            </section>
          </section>
        </section>
      </section>
    </article>
  )
}